import { theme } from "./../../../constants/StyledComponents";
import styled from "styled-components";

export const StyledPageError = styled.div`
  background-color: ${theme.colors.purple_5};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & .error-403-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  & .error-403-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  & .error-403-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  & .error-403-message {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
